import gql from 'graphql-tag';

import { AccountSearchSubscriptionFeaturesDetails } from '../../../../../../graphql/fragments/account';

export const AccountForSearchSubscriptionFeaturesQuery = gql`
  query accountForSearchSubscriptionFeatures {
    me {
      id
      ...AccountSearchSubscriptionFeaturesDetails
    }
  }
  ${AccountSearchSubscriptionFeaturesDetails}
`;

export const SearchSubscriptionFeaturesRequirementsQuery = gql`
  query searchSubscriptionFeaturesRequirements {
    searchSubscriptionFeaturesRequirements(platform: WEB) {
      free_joins_enabled {
        id
        plan
        billing_period
        price {
          currency
          value
        }
      }
      qr_code_enabled {
        id
        plan
        billing_period
        price {
          currency
          value
        }
      }
      marketing_prints_enabled {
        id
        plan
        billing_period
        price {
          currency
          value
        }
      }
      white_label_marketing_prints_enabled {
        id
        plan
        billing_period
        price {
          currency
          value
        }
      }
      photo_watermark_enabled {
        id
        plan
        billing_period
        price {
          currency
          value
        }
      }
      slideshow_enabled {
        id
        plan
        billing_period
        price {
          currency
          value
        }
      }
      video_album_enabled {
        id
        plan
        billing_period
        price {
          currency
          value
        }
      }
      members_view_enabled {
        id
        plan
        billing_period
        price {
          currency
          value
        }
      }
      custom_tags_enabled {
        id
        plan
        billing_period
        price {
          currency
          value
        }
      }
      face_highlights_enabled {
        id
        plan
        billing_period
        price {
          currency
          value
        }
      }
      prints_discount_enabled {
        id
        plan
        billing_period
        price {
          currency
          value
        }
      }
    }
  }
`;
